import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { profileApi as n } from "@maat/api-main";
import { authQueryKeys as r } from "@maat/store-auth";
//#region src/profile/useCreateHostProfileMutation.ts
var i = () => {
	let i = t();
	return e({
		mutationFn: n.createHostProfile,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: r.state() });
		}
	});
};
//#endregion
export { i as useCreateHostProfileMutation };
